import { render, staticRenderFns } from "./SelezionaProssimo.vue?vue&type=template&id=4a028f21"
import script from "./SelezionaProssimo.vue?vue&type=script&lang=js"
export * from "./SelezionaProssimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports